//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('choiceProdPriceGrp', {
//        templateUrl: 'views/components/views/choiceProdPriceGrp/choiceProdPriceGrp.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'choiceProdPriceGrpService', 'productService', function ($stateParams, stateService, translateService, modalService, choiceProdPriceGrpService, productService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let choiceProdPriceGrpKeyno = $stateParams.choiceprodpricegrp_keyono;
//            let prodIdChoice = $stateParams.prod_id_choice;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                choiceProdPriceGrpKeyno: choiceProdPriceGrpKeyno,
//                colourGroupButtons: [
//                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('colorgrps') }
//                ],
//                colourGroupButtonsExpanded: [
//                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('colorgrps') },
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('colorgrpmenu', { colorgrp_id: vm.model.edit.colorgrp_id }) }
//                ],
//                edit: {},
//                selectListColourGroups: [],
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALLS

//            async function loadEdit() {
//                vm.model.edit = (await choiceProdPriceGrpService.getEdit({
//                    choiceprodpricegrp_keyono: choiceProdPriceGrpKeyno,
//                    prod_id_choice: prodIdChoice
//                }))[0];
//            }

//            async function loadColourGroups() {
//                vm.model.selectListColourGroups = await productService.listColourGroups();
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                choiceProdPriceGrpService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    choiceProdPriceGrpService.deleteItem(vm.model.edit).then((response) => {
//                        if (response[0].errorcode !== '0') {
//                        	modalService.show({
//                        		type: 'warning',
//                        		title: translations.error,
//                        		message: response[0].errormessage,
//                        		buttons: [{
//                        			label: translations.ok,
//                        			cssClass: 'btn-warning',
//                        			action: function (dialogItself) {
//                        				dialogItself.close();
//                        				vm.model.lockedDelete = false;
//                        			}
//                        		}]
//                        	});
//                        } else {
//                        	vm.model.lockedDelete = false;
//                        	stateService.back();
//                        }
//                    }, () => vm.model.lockedDelete = false);
//                }, () => vm.model.lockedDelete = false);
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                loadEdit();
//                loadColourGroups();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
